import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useQuery } from 'react-apollo';
import classNames from 'classnames';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';

import Spinner from '../../../../components/global/Spinner';
import { RosterIdentityHistory } from '../../../../graphql/queries/roster-identitiy';
import useSliceFilterOpts from '../../../../components/product/hooks/useSliceFilterOpts';
import { DATE_FORMAT_WITH_TIME } from '../../../../constants/dates';
import Button from '../../../../components/global/Button';
import { formatPriceForDisplay } from '../../../../util/format-money';
import TablePagination from '../../../../components/global/TablePagination';
import { AlbumPurchasedCustomPrintDetailsModal } from '../../views/Album/AlbumCustomPrints/AlbumCustomPrintDetails';
import { ALBUM_PURCHASED_CUSTOM_PRINT_DETAILS_MODAL } from '../../views/Album/AlbumCustomPrints/AlbumCustomPrintDetails/modal';
import { openModal as openModalAction } from '../../../../actions/modal-actions';

const propTypes = {
  rosterIdentityId: PropTypes.string,
  openModal: PropTypes.func.isRequired,
};

const RosterIdentityPurchaseHistory = ({ rosterIdentityId, openModal }) => {
  const { onPageChange, filter } = useSliceFilterOpts({
    initialFilter: { limit: 10 },
  });
  const { data: { me } = {}, loading } = useQuery(RosterIdentityHistory, {
    variables: {
      limit: filter.limit,
      offset: filter.offset,
      roster_identity_ids: [rosterIdentityId],
    },
  });

  const [rosterIdentity] = me?.roster_identities.records ?? [];

  if (!rosterIdentity) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  const purchasedCustomPrintsRecords =
    rosterIdentity?.purchased_custom_prints.records ?? [];
  const purchasedCustomPrintsTotal =
    rosterIdentity?.purchased_custom_prints.total ?? 0;

  const totalPages =
    purchasedCustomPrintsTotal > 0
      ? Math.ceil(purchasedCustomPrintsTotal / filter.limit)
      : 1;

  const tableClasses = classNames({
    'table table-striped mb-3': true,
    'table-loading': loading,
  });

  return (
    <Fragment>
      <table className={tableClasses}>
        <thead className="text-bold text-sm">
          <tr>
            <td>Date</td>
            <td>Address</td>
            <td>Price</td>
            <td>&nbsp;</td>
          </tr>
        </thead>

        <tbody>
          {purchasedCustomPrintsRecords.length === 0 && !loading && (
            <tr>
              <td colSpan={4} rowSpan={2}>
                <p>No orders have been placed for this identity.</p>
              </td>
            </tr>
          )}
          {purchasedCustomPrintsRecords.map(purchasedCustomPrint => {
            return (
              <tr>
                <td>
                  {moment(purchasedCustomPrint.created_at).format(
                    DATE_FORMAT_WITH_TIME,
                  )}
                </td>
                <td>
                  {purchasedCustomPrint.roster_identity_linked_identity_address
                    ?.address_line_1 ?? 'N/A'}
                </td>
                <td>
                  ${formatPriceForDisplay(purchasedCustomPrint.price.value)}
                </td>
                <td>
                  <Button
                    btnStyle="link"
                    onClick={() => {
                      openModal(ALBUM_PURCHASED_CUSTOM_PRINT_DETAILS_MODAL, {
                        purchasedCustomPrintId: purchasedCustomPrint.id,
                      });
                    }}
                  >
                    Details
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {totalPages > 1 && (
        <TablePagination
          onPageChange={onPageChange}
          page={filter.page}
          totalPages={totalPages}
          loading={loading}
        />
      )}

      <AlbumPurchasedCustomPrintDetailsModal albumInformationHidden />
    </Fragment>
  );
};

const mapDispatchToProps = {
  openModal: openModalAction,
};

RosterIdentityPurchaseHistory.propTypes = propTypes;

export default compose(connect(null, mapDispatchToProps))(
  RosterIdentityPurchaseHistory,
);
